import React, { useContext, useState } from 'react';
import { RxCross2 } from "react-icons/rx";
import ModalHeading from './modal-heading';
import Button from './custom-btn';
import { AccountsContext } from '../context/account-context';
import Loader from './loader';

const UpdateStatusModal = ({
    modalTitle = 'Change Status',
    selectedRow,
    statusKey = 'status',
    statusOptions = [],
    updateStatusApi,
    setIsUpdateStatusModalOpen,
    setSelectedRow,
    setData,
    fetchData,
    uniqueIdKey = 'id',
    fromVehiclesTab = false,
    globalDataloading
}) => {
    const { accountId } = useContext(AccountsContext);
    const [selectedStatus, setSelectedStatus] = useState(selectedRow?.[statusKey] || '');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);



    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
    };

    const handleSave = async () => {
        if (!selectedRow || !updateStatusApi || !selectedStatus) return;

        try {
            setIsLoading(true);
            setErrorMessage(null);
            const id = selectedRow[uniqueIdKey];

            const response = await updateStatusApi(accountId, id, selectedStatus);
            console.log(response)
            if (response?.status === 200 || response?.success) {
                setData?.(prev =>
                    prev.map(item =>
                        item[uniqueIdKey] === id
                            ? { ...item, [statusKey]: selectedStatus }
                            : item
                    )
                );

                setSuccessMessage('Status updated successfully!');
                setTimeout(() => {
                    setIsUpdateStatusModalOpen(false);
                    setSelectedRow(null);
                    setSuccessMessage(null);
                    fromVehiclesTab && fetchData?.('Fuel');
                }, 1000);
            } else {
                setErrorMessage(response?.data?.message || 'Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
            setErrorMessage(error?.message || 'An unexpected error occurred');
        } finally {
            setIsLoading(false);
        }
    };


    console.log(selectedRow)
    return (
        <div className="space-y-3 pt-3 ">
            <div className='px-4 border-b'>
                <div className='  pb-2 relative'>
                    <ModalHeading className="text-left">{modalTitle}</ModalHeading>
                    <button
                        className='hover:scale-105 absolute -top-2 -right-2 bg-white border p-2 rounded-full'
                        onClick={() => setIsUpdateStatusModalOpen(false)}
                    >
                        <RxCross2 className='text-xl' />
                    </button>
                </div>
            </div>

            {successMessage && (
                <div className="mb-4 px-4 py-2 bg-green-100 text-green-800 rounded-md text-sm text-center">
                    {successMessage}
                </div>
            )}

            {errorMessage && (
                <div className="mb-4 px-4 py-2 bg-red-100 text-red-800 rounded-md text-sm text-center">
                    {errorMessage}
                </div>
            )}

            {globalDataloading ?
                <Loader />
                :
                <>
                    <div className="space-y-2 pt-3 px-4">
                        <div className="flex flex-col gap-4">
                            {statusOptions.map(option => (
                                <div key={option.slug} className="flex items-center">
                                    <input
                                        type="radio"
                                        id={option.slug}
                                        name="status"
                                        value={option.slug}
                                        checked={selectedStatus === option.slug}
                                        onChange={handleStatusChange}
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <label htmlFor={option.slug} className="ml-2 text-sm text-gray-700">
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex justify-end px-4 mt-4">
                        <Button
                            onClick={handleSave}
                            label={'Save'}
                            loading={isLoading}
                            loadingLabel='Saving...'
                            type='submit'
                            disabled={isLoading}
                            className={`bg-btnBg rounded-lg !py-1 text-white`}
                        />
                    </div>
                </>
            }


        </div>
    );
};

export default UpdateStatusModal;
